import React from "react";
import "./layout.css";


// Component for wrapping the app in a container for dev mode - simulating the BASAL WP theme

function Layout({children}) {
  if (process.env.NODE_ENV === "production") return <>{children}</>;
  return (
    <section className="sectionStyle">
      <div className="containerStyle" >{children}</div>
    </section>
  );
}

export default Layout;
